import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "CRM & ERP Sync", desc: "Clean movement of data between sales, operations, finance, and delivery systems." },
  { title: "Payments & Commerce", desc: "Gateway, checkout, and transaction workflows integrated with the rest of the business stack." },
  { title: "Messaging Channels", desc: "WhatsApp, email, and notification workflows connected to the right operational triggers." },
  { title: "Automation Middleware", desc: "Custom bridges and orchestration logic where prebuilt connectors are not enough." },
  { title: "Third-Party APIs", desc: "Vendor integrations handled with clear contracts, monitoring, and fallback thinking." },
  { title: "Operational Reliability", desc: "Retry logic, validation, and exception handling so integrations remain usable in production." },
];

const Integrations = () => (
  <StitchFeaturePage
    label="INTEGRATIONS & AUTOMATION"
    title="Systems that"
    titleAccent="talk to each other."
    subtitle="Integration work that reduces manual work, closes data gaps, and keeps operations moving."
    features={features}
    ctaLabel="CONNECT YOUR STACK"
  />
);

export default Integrations;
